import services from './../../../services/service'; // Service Class
import validation from './../../../services/validation'; // Validation
import commonfunctions from "./../../Account/Resources/commonfunctions";

let service = new services();
let validator = new validation();
export default {
    name: 'ManageTemplate',
    mixins: [commonfunctions],
    data () {
        return {
            path: (this.$route.path).replace('/',''),
            path_name: this.$route.name,
            sellpoint_name:(this.$route.path).split('/')[1],
            product_name:(this.$route.path).split('/')[2],
        }
    },
    components: {},
    methods: {
   
        preset() {
            this.loading = true;
            
            //../
            let self = this;
            localforage.getItem(service.udb_name, function(err, value) { //quick with the callback version
                if(value != undefined) {
                    self.user = value;
                    self.getSellpoints(self.user.user_id);
                    /*---call from server
                    // localforage.getItem(service.bdb_name, function(err, value) { //quick with the callback version
                    //     if(value != undefined) {
                    //         self.sellpoint = value;
                    //         //get some core details
                    //         self.getSellpoints(self.user.user_id);
                    //        // self.setPage();
                    //     }else{
                    //         //get user businesses from server
                    //         self.getSellpoints(self.user.user_id);
                    //         //self.loading = false;
                    //     }
                    // });
                    */
                }else {
                    self.loading = false;
                    self.$router.push('/login')
                }
            });
            
        },

        
        setPage(){
            this.loading = true;
            //get Orders
            this.getAppBusinessOrders();
            //get prnding order payments
            this.getAppBusinessOrdersPendingPayments();
        },
     
    },
    created: function(){
        this.preset();
       // if(this.path_name == 'Sellpoint'){this.setPageHeaders();} //for sellpoint only
    }
}


// WEBPACK FOOTER //
// ./src/pages/Manage/Template/script.js